var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaunch2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32.381,
    height: 32.381,
    rx: 16.1905,
    fill: "#D7F9FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.69048 9.52539V17.8587C8.69048 20.2157 8.69048 21.3942 9.42271 22.1265C10.1549 22.8587 11.3335 22.8587 13.6905 22.8587H23.6905",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1905 17.8587L13.8988 15.1504C14.4355 14.6136 14.7039 14.3453 15.0177 14.2568C15.2397 14.1942 15.4746 14.1942 15.6966 14.2568C16.0104 14.3453 16.2787 14.6136 16.8155 15.1504C17.3522 15.6871 17.6206 15.9555 17.9344 16.044C18.1564 16.1066 18.3912 16.1066 18.6132 16.044C18.9271 15.9555 19.1954 15.6871 19.7321 15.1504L22.8571 12.0254",
    stroke: "#007E8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch2);
export default __webpack_public_path__ + "static/media/launch-2.f28770f1f1766a73924e6301a863f1d6.svg";
export { ForwardRef as ReactComponent };